export const personalHistoryCol = {
    change_datetime: "0",
    attribute_name: "1",
    old_value: "4",
    new_value: "3",
    authorized: "5",
    employee_first_name: "6",
    reason: "7"
};

export const sortDirectionConst = {
    asc: "0",
    desc: "1"
};